import React from 'react';
import { useTranslation } from 'react-i18next';

const SearchBar = ({
  value = '',
  onChange,
  placeholder,
  className = '',
  id = 'manage-search-input'
}) => {
  const { t } = useTranslation();

  const handleClear = () => {
    if (onChange) {
      onChange('');
    }
  };

  const displayPlaceholder = placeholder || t('search') || 'Sök...';

  return (
    <div className={`search-bar-container ${className}`.trim()}>
      <span className="search-bar-icon" aria-hidden="true">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </span>
      <input
        id={id}
        type="text"
        className="search-bar-input"
        value={value}
        onChange={(e) => onChange && onChange(e.target.value)}
        placeholder={displayPlaceholder}
        aria-label={displayPlaceholder}
        autoComplete="off"
      />
      {value && (
        <button
          type="button"
          className="search-bar-clear-button"
          onClick={handleClear}
          aria-label={t('clear-search') || 'Rensa sökning'}
          title={t('clear-search') || 'Rensa sökning'}
        >
          ✕
        </button>
      )}
    </div>
  );
};

export default SearchBar;
export { SearchBar };
